import Vue from 'vue'
import router from '@/router'
import store from '@/store/store'

import mixins from '@/mixins/mixins'
import '@/filters/filters'

import '@/plugins/element.js'
import '@/plugins/vue-progressbar.js'

import App from '@/App'

import Spacer from '@/components/Spacer/Spacer'
import GridContainer from '@/components/GridContainer/GridContainer'

Vue.config.productionTip = false

Vue.prototype.$isProduction = process.env.NODE_ENV === 'production'
Vue.prototype.$isDevelopment = process.env.NODE_ENV === 'development'

Vue.mixin(mixins)

Vue.component('GridContainer', GridContainer)
Vue.component('Spacer', Spacer)

export default new Vue({
  router,
  store,
  render: function(h) { return h(App) }
}).$mount('#app')
